import React, { useEffect } from 'react';
import get from 'lodash/get';
import VideoPopup from '../Video';
import DeviationMediaService from '../../utils/DeviationMediaService';
import { getSource } from '../../DeviationViews/_helpers';
var DeviationVideoPopup = function (_a) {
    var onRequestClose = _a.onRequestClose, autoPlay = _a.autoPlay, posterFrame = _a.posterFrame, deviation = _a.deviation, deviationId = _a.deviationId, fetchDeviation = _a.fetchDeviation, _b = _a.type, type = _b === void 0 ? 'art' : _b;
    // on component mount, fetch the deviation
    useEffect(function () {
        fetchDeviation({ deviationid: deviationId, type: type });
    }, [deviationId, type, fetchDeviation]);
    var videoSource = deviation &&
        get(getSource(DeviationMediaService.getMediaByType(deviation, 'video')), 'src');
    // If no posterFrame is provided use the preview
    var posterSource = posterFrame ||
        (deviation &&
            get(getSource(DeviationMediaService.getMediaByType(deviation, 'preview')), 'src'));
    return (React.createElement(VideoPopup, { source: videoSource, posterFrame: posterSource, onRequestClose: onRequestClose, autoPlay: autoPlay }));
};
DeviationVideoPopup.displayName = 'DeviationVideoPopup';
export default DeviationVideoPopup;
//# sourceMappingURL=DeviationVideo.js.map